<template>
  <UForm
    ref="form"
    :schema="schema"
    :state="state"
    class="space-y-3"
    @submit="submitForm"
  >
    <TGrid :cols="12">
      <UFormField
        class="grid-rows-1 col-span-12"
        :label="t('views.cottage-contact-whatsapp.form.date.label')"
        name="dates"
      >
        <TDateInput
          v-model:dates="state.dates"
          :item-id="props.item.id"
          clear-dates
          size="lg"
          @update:dates="updateDates"
        />
      </UFormField>
      <UFormField
        class="grid-rows-1 col-span-12 mt-5"
        :label="t('views.cottage-contact-whatsapp.form.people.label')"
        name="people"
      >
        <UInput
          v-model="state.people"
          type="number"
          min="0"
          icon="i-heroicons-users-20-solid"
          size="lg"
          :placeholder="
            t('views.cottage-contact-whatsapp.form.people.placeholder')
          "
          :aria-label="t('views.cottage-contact-whatsapp.form.people.label')"
          :title="t('views.cottage-contact-whatsapp.form.people.title')"
          autocomplete="on"
          @change="updatePeople"
        />
      </UFormField>
      <div class="grid-rows-1 col-span-12">
        <UButton
          class="w-full flex justify-center mt-6"
          color="neutral"
          variant="subtle"
          size="lg"
          type="submit"
          :disabled="!isValid"
        >
          {{ t('views.cottage-contact-whatsapp.price.view') }}
        </UButton>
      </div>
    </TGrid>
  </UForm>
</template>
<script setup lang="ts">
import { z } from 'zod'
import type { CottageContactWhatsAppPagePricesForm } from '../entities/CottageContactWhatsAppPagePrices'
import type { DatePickerRangeObject } from '@angelblanco/v-calendar/dist/types/src/use/datePicker.js'
import type { CottageContactWhatsAppPage } from '../entities/CottageContactWhatsAppPage'

type itemType = Pick<CottageContactWhatsAppPage, 'id'>

interface propsInterface {
  item: itemType
}

const props = defineProps<propsInterface>()

const state = reactive({
  dates: null as DatePickerRangeObject | null,
  people: undefined,
})

const schema = z.object({
  dates: z.custom<DatePickerRangeObject>().nullable(),
  people: z
    .number()
    .or(z.literal(''))
    .transform(value => (value === '' ? undefined : value))
    .optional(),
})

const isValid = computed(() => {
  if (state.dates && state.dates.start && state.dates.end) {
    return true
  } else {
    return false
  }
})

const emits = defineEmits<{
  (
    e: 'submit',
    CottageContactWhatsAppPagePricesForm: CottageContactWhatsAppPagePricesForm,
  ): void
  (e: 'update-dates', value: DatePickerRangeObject): void
  (e: 'update-people', value: number): void
}>()

async function submitForm(event: any) {
  const result = schema.safeParse(event.data)
  if (result.success && state.dates) {
    const parsedData: CottageContactWhatsAppPagePricesForm = {
      dates: state.dates,
      people: state.people || null,
    }

    emits('submit', parsedData)
  }
}

const updateDates = () => {
  if (state.dates) {
    emits('update-dates', state.dates)
  }
}

const updatePeople = () => {
  if (state.people) {
    emits('update-people', state.people)
  }
}
</script>
